import { render, staticRenderFns } from "./ListLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=template&id=548d3c9c&scoped=true"
import script from "./ListLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
export * from "./ListLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
import style0 from "./ListLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=style&index=0&id=548d3c9c&prod&lang=scss&scoped=true"
import style1 from "./ListLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=style&index=1&id=548d3c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d3c9c",
  null
  
)

export default component.exports